<template>
  <div class="home">
    <v-carousel
      hide-delimiters
      hide-arrows
      :left-control-icon="false"
      :right-control-icon="false"
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
    <!-- <div class="container">
      <backtohauptspeise></backtohauptspeise>
    </div> -->
    <v-card>
      <v-card-title class="display-1">
        Schweinefleisch
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
// import Backtohauptspeise from './Backtohauptspeise.vue';
export default {
  // components: {
  //   Backtohauptspeise,
  // },
  name: 'Schweineleisch',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/gebratenesschweinefleischseitlich.jpg'),
        },
        {
          src: require('../assets/images/gebratenesschweinefleischmithintergrund.jpg'),
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: '130',
          speise: 'Schweinefleisch mit Thai Sauce (scharf)',
          allergene: '(A, F)',
          preis: '10,20 €',
        },
        {
          nummer: '131',
          speise: 'Schweinefleisch Ganbian (scharf)',
          allergene: '(A, F)',
          preis: '10,70 €',
        },
        {
          nummer: '132',
          speise: 'Schweinefleisch nach Chop Suey',
          allergene: '(A, F)',
          preis: '10,30 €',
        },
        {
          nummer: '133',
          speise: 'Schweinefleisch nach Sichuan Art (scharf)',
          allergene: '(A,F)',
          preis: '10,30 €',
        },
        {
          nummer: '134',
          speise: 'Schweinefleisch mit Bambus und Pilzen',
          allergene: '(A,F)',
          preis: '10,30 €',
        },
        {
          nummer: '135',
          speise: 'Gebackenes Schweinefleisch Sesam',
          allergene: '(A,F)',
          preis: '10,10 €',
        },
        {
          nummer: '136',
          speise: 'Gebratenes Schweinefleisch mit Gemüse',
          allergene: '(A,F)',
          preis: '10,10 €',
        },
        {
          nummer: '137',
          speise: 'Gebratenes Schweinefleisch mit Paprika (scharf)',
          allergene: '(A, F)',
          preis: '10,10 €',
        },
        {
          nummer: '138',
          speise: 'Gebratenes Schweinefleisch mit Curry Sauce',
          allergene: '(A, F)',
          preis: '10,10 €',
        },
        {
          nummer: '139',
          speise: 'Gebratenes Schweinefleisch mit Zwiebeln',
          allergene: '(A, F)',
          preis: '10,10 €',
        },
        {
          nummer: '140',
          speise: 'Gebratenes Schweinefleisch mit Zucchini',
          allergene: '(A, F)',
          preis: '10,10 €',
        },
        {
          nummer: '141',
          speise: 'Gebratenes Schweinefleisch mit Teriyaki Sauce',
          allergene: '(A, F)',
          preis: '10,10 €',
        },
        {
          nummer: '142',
          speise: 'Gebratenes Schweinefleisch mit Tofu und Gemüse',
          allergene: '(A, F)',
          preis: '10,30 €',
        },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
